/**
 * Chat API service — REST calls for AI chat sessions and messages.
 * Streaming is handled separately via the native Fetch API in ChatContext.
 */
import { api } from './api';

export interface ChatSession {
  id: number;
  title: string | null;
  created_at: string;
  updated_at: string;
  message_count?: number;
}

export interface ChatMessage {
  id: number;
  session_id: number;
  role: 'user' | 'assistant' | 'system';
  content: string;
  page_context: Record<string, unknown> | null;
  tokens_used: number | null;
  created_at: string;
}

export interface PageContext {
  route: string;
  entity_type?: string;
  entity_id?: number;
  extra?: Record<string, unknown>;
}

const chatApi = {
  createSession: (title?: string): Promise<ChatSession> =>
    api.post('/chat/sessions', { title: title ?? null }),

  listSessions: (skip = 0, limit = 20): Promise<ChatSession[]> =>
    api.get('/chat/sessions', { skip: String(skip), limit: String(limit) }),

  getMessages: (sessionId: number): Promise<ChatMessage[]> =>
    api.get(`/chat/sessions/${sessionId}/messages`),

  deleteSession: (sessionId: number): Promise<void> =>
    api.delete(`/chat/sessions/${sessionId}`),
};

export default chatApi;
